<main class="login-page d-flex align-items-center justify-content-center min-vh-100 p-2 p-md-4">
  <section class="login-card row g-0 overflow-hidden shadow-lg">
    <div class="col-12 col-lg-5 login-brand-panel d-flex align-items-center justify-content-center p-3 p-lg-5">
      <img class="login-logo d-block mx-auto" ngSrc="../../../assets/white_text_logo.png" alt="My Lab Manager logo" height="334"
           width="1557"/>
    </div>

    <div class="col-12 col-lg-7 bg-white login-form-panel p-3 p-sm-4 p-md-5">
      <div class="mb-4">
        <h2 class="fw-bold mb-2">{{ forgotPasswordMode ? 'Ресетирање на лозинка' : 'Најава' }}</h2>
        <p class="text-muted mb-0">
          {{ forgotPasswordMode ? 'Внесете ја вашата е-пошта за да добиете линк за ресетирање.' : 'Внесете ги вашите кориснички податоци.' }}
        </p>
      </div>

      @if (error) {
        <app-error-alert class="d-block mb-4" [title]="forgotPasswordMode ? 'Неуспешно барање' : 'Неуспешна најава'" [message]="error"></app-error-alert>
      }

      @if (forgotPasswordMode && forgotPasswordSent) {
        <div class="alert alert-success rounded-4 mb-4" role="alert">
          Ако постои клиент со внесената е-пошта, ќе добиете порака со линк за ресетирање на лозинката.
        </div>
      }

      @if (!forgotPasswordMode) {
        <form #loginForm="ngForm" (ngSubmit)="loginForm.valid && login()" class="d-flex flex-column gap-3">
          <div>
            <label class="form-label fw-semibold" for="email">Е-пошта</label>
            <input
              class="form-control login-input"
              [class.is-invalid]="emailModel.invalid && (emailModel.touched || loginForm.submitted)"
              id="email"
              [(ngModel)]="email"
              #emailModel="ngModel"
              name="email"
              type="email"
              autocomplete="email"
              email
              required/>
            @if (emailModel.errors?.['required'] && (emailModel.touched || loginForm.submitted)) {
              <div class="invalid-feedback d-block">Полето е задолжително.</div>
            }
            @if (emailModel.errors?.['email'] && (emailModel.touched || loginForm.submitted)) {
              <div class="invalid-feedback d-block">Внесете валидна е-пошта.</div>
            }
          </div>

          <div>
            <label class="form-label fw-semibold" for="password">Лозинка</label>
            <mat-form-field
              appearance="outline"
              class="login-password-field w-100"
              [class.login-password-field-invalid]="passwordModel.invalid && (passwordModel.touched || loginForm.submitted)">
              <input
                matInput
                id="password"
                [(ngModel)]="password"
                #passwordModel="ngModel"
                name="password"
                [type]="showPassword ? 'text' : 'password'"
                autocomplete="current-password"
                required/>
              <button
                mat-icon-button
                matSuffix
                type="button"
                class="login-password-toggle"
                (click)="togglePasswordVisibility()"
                (mousedown)="$event.preventDefault()"
                [attr.aria-label]="showPassword ? 'Сокриј лозинка' : 'Прикажи лозинка'">
                <mat-icon>{{ showPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
              </button>
            </mat-form-field>
            @if (passwordModel.errors?.['required'] && (passwordModel.touched || loginForm.submitted)) {
              <div class="invalid-feedback d-block">Полето е задолжително.</div>
            }
          </div>

          <div class="d-flex justify-content-end">
            <button type="button" class="btn btn-link primary-color fw-semibold p-0 text-decoration-none" (click)="openForgotPassword()">
              Ја заборави лозинката?
            </button>
          </div>

          <button type="submit" class="btn login-button w-100 mt-2" [disabled]="loading">
            @if (loading) {
              <span class="spinner-border spinner-border-sm me-2" aria-hidden="true"></span>
              Најавување...
            } @else {
              Најави се
            }
          </button>
        </form>
      } @else {
        <form #forgotPasswordForm="ngForm" (ngSubmit)="forgotPasswordForm.valid && sendResetPassword()" class="d-flex flex-column gap-3">
          <div>
            <label class="form-label fw-semibold" for="forgotPasswordEmail">Е-пошта</label>
            <input
              class="form-control login-input"
              [class.is-invalid]="forgotPasswordEmailModel.invalid && (forgotPasswordEmailModel.touched || forgotPasswordForm.submitted)"
              id="forgotPasswordEmail"
              [(ngModel)]="forgotPasswordEmail"
              #forgotPasswordEmailModel="ngModel"
              name="forgotPasswordEmail"
              type="email"
              autocomplete="email"
              email
              required/>
            @if (forgotPasswordEmailModel.errors?.['required'] && (forgotPasswordEmailModel.touched || forgotPasswordForm.submitted)) {
              <div class="invalid-feedback d-block">Полето е задолжително.</div>
            }
            @if (forgotPasswordEmailModel.errors?.['email'] && (forgotPasswordEmailModel.touched || forgotPasswordForm.submitted)) {
              <div class="invalid-feedback d-block">Внесете валидна е-пошта.</div>
            }
          </div>

          <button type="submit" class="btn login-button w-100 mt-2" [disabled]="loading">
            @if (loading) {
              <span class="spinner-border spinner-border-sm me-2" aria-hidden="true"></span>
              Испраќање...
            } @else {
              Испрати
            }
          </button>

          <button type="button" class="btn btn-light rounded-4 fw-semibold" (click)="backToLogin()" [disabled]="loading">
            Назад
          </button>
        </form>
      }
    </div>
  </section>
</main>
